import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyereact = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.88729 15.75C4.45406 15.75 1.75965 11.5561 1.08605 10.3306C0.971316 10.1222 0.971316 9.87422 1.08605 9.66937C1.75965 8.44391 4.45406 4.25 9.88729 4.25C15.3205 4.25 18.0186 8.44391 18.6885 9.66937C18.8033 9.87781 18.8033 10.1258 18.6885 10.3306C18.0186 11.5561 15.3205 15.75 9.88729 15.75ZM9.89469 6.04687C7.64442 6.04687 5.82347 7.81859 5.82347 10C5.82347 12.1814 7.64812 13.9531 9.89469 13.9531C12.1413 13.9531 13.9659 12.1814 13.9659 10C13.9659 7.815 12.1413 6.04687 9.89469 6.04687ZM9.89469 12.5156C8.46236 12.5156 7.30392 11.3908 7.30392 10C7.30392 8.60922 8.46236 7.48437 9.89469 7.48437C11.327 7.48437 12.4855 8.60922 12.4855 10C12.4855 11.3908 11.3233 12.5156 9.89469 12.5156Z",
		fill: "#8493A6"
	})
});
export default SvgEyereact;
